import { FormHelperText, Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectQuestionnaire } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  xs?: number;
  changeValue: (value: number, name?: string) => void;
  disabled?: boolean;
  showAll: boolean;
  error?: string;
  type: "open" | "mcq" | "all";
}
const QuestionnaireFiled = (props: TProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectQuestionnaire);
  useEffect(() => {
    dispatch(actions.getQuestionnaireList({ type: props.type }));
    return () => {};
  }, []);

  const hasError = !!props?.error;

  const options: SelectOption[] = List.map((item: any) => ({
    label: item.name,
    value: item.id,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("ORGANIZATIONS.QUESTIONNAIRE_NAME")}
      </label>
      <SearchableSelect
        options={options}
        value={props.value ?? ""}
        onChange={(val, raw) => {
          props.changeValue(Number(val), raw?.name ?? "");
        }}
        disabled={props.disabled}
        searchable
        error={hasError}
        placeholder={t("ORGANIZATIONS.SELECT_QUESTIONNAIRE_NAME") as string}
        className={styles.textEnabled}
        showAllOption={
          props.showAll ? { label: t("ORGANIZATIONS.ALL"), value: 0 } : undefined
        }
      />
      {hasError && <FormHelperText error>{props?.error}</FormHelperText>}
    </Grid>
  );
};
export default QuestionnaireFiled;
